import { MsalProvider } from '@azure/msal-react';
import { CssBaseline } from '@mui/material';
import { logout, setAccessToken, setLoader, setprofile } from 'features/auth/AuthSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRoutes } from 'react-router-dom';
import { useGetLoginMutation, useGetProfileMutation } from 'services/RtkServices';
import Swal from 'sweetalert2';
import '../fake-db';
// import { fetchToken, onMessageListener } from '../firebase';
import { MatxTheme } from './components';
import { SettingsProvider } from './contexts/SettingsContext';
import routes from './routes';

const App = ({ instance }) => {
  const [isTokenFound, setTokenFound] = useState(false);
  const [getProfile, { isLoading, data: profileData, error }] = useGetProfileMutation();
  const [getLogin] = useGetLoginMutation();
  let dispatch = useDispatch();
  const { pathname } = useLocation();
  const content = useRoutes(routes);
  // fetchToken(setTokenFound);
  // console.log('isTokenFound---->', isTokenFound);
  // onMessageListener()
  //   .then((payload) => {
  //     console.log('notficationData----> ', payload);
  //   })
  //   .catch((err) => console.log('failed: ', err));
  const ErrorMsg = (error, msg) => {
    Swal.fire({
      icon: error,
      title: msg
    });
  };

  let { accessToken, ssoToken, user, loader, errorMsg } = useSelector((store) => store.auth);
  useEffect(() => {
    const getUser = async () => {
      try {
        let payload = {
          usertype: localStorage.getItem('login_type')
        };
        dispatch(setLoader({ loader: true, errorMsg: '' }));
        const res = await getProfile(payload);
        if (res?.data?.statusCode === 200) {
          dispatch(setprofile({ isAuthenticated: true, user: res?.data?.adminUserDataResposne }));
          dispatch(setLoader({ loader: false, errorMsg: '' }));
        } else if (res?.data?.statusCode === 404) {
          ErrorMsg('error', res?.data?.responseMessage);
          dispatch(logout());
          dispatch(setLoader({ loader: false, errorMsg: res?.data?.responseMessage }));
          ErrorMsg('error', res?.data?.responseMessage);
        } else if (res?.data?.statusCode === 409) {
          ErrorMsg('error', res?.data?.responseMessage);
          dispatch(setLoader({ loader: false, errorMsg: res?.data?.responseMessage }));
        }
      } catch (error) {
        dispatch(setLoader({ loader: false, errorMsg: error }));
        ErrorMsg('error', error);
      }
    };

    if (accessToken) {
      getUser();
    }
  }, [accessToken]);

  return (
    <SettingsProvider>
      <MatxTheme>
        <MsalProvider instance={instance}>
          <CssBaseline />
          {content}
        </MsalProvider>
      </MatxTheme>
    </SettingsProvider>
  );
};

export default App;
